<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="ORIM-Book-Title--Title-Page-" id="_idParaDest-1"><span class="CharOverride-1"><a id="_idTextAnchor000"></a>The Conan the Barbarian <a id="_idTextAnchor001"></a>Stories</span></p>
<p class="ORIM-Author-Name--Title-Page-"><span class="CharOverride-1">Robert E. Howard</span></p>
<p class="ORIM-Author-Name--Title-Page-"><img alt="logo2" src="image/logo2.jpg"/><a id="_idTextAnchor004"></a></p>
<p class="ORIM-Part-Title-Break--Body-" id="_idParaDest-2"><span class="CharOverride-1"><a id="_idTextAnchor002"></a>The Phoenix on the Sword</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Conan.vue?6e640566